import * as Yup from 'yup'

import { email, pin } from '../../utils/yup'

export const CONTACT_SHARE_VEHICLE_SCHEMA = Yup.object().shape({
  emailInvited: email,
})

export const CONFIRM_PIN_TO_SHARE_VEHICLE_SCHEMA = Yup.object().shape({
  pin,
})
